<template>
  <div class="coat">
    <!-- 头部 -->
    <div class="section">
      <img src="../assets/product/riskheader.png" alt="">
    </div>
    <!-- 内容提示 -->
    <div class="tips">
      <div>
        <img src="../assets/product/icon.png" alt="">
        <span>首页 > 产品与解决方案>大数据智能风控解决方案</span>
      </div>
    </div>
    <!-- 整体内容 -->
    <div class="main">
      <div style="margin-bottom: 10px;">方案概述</div>
      <p>为中小银行提供一站式智能网点服务，通过网点布局改造、智能机具使用和网点服务流程革新， </p>
      <p> 有效提升客户服务体验感受，有效提升网点产能，实现网点运营从业务结算</p>
      <p> 型向营销服务型转变，重塑银行物理渠道的价值和优势。</p>
      <div class="title">全流程服务</div>
      <div>
        <img src="../assets/product/risk1.png" alt="">
      </div>
      <div class="title">审批流程</div>
      <div>
        <img src="../assets/product/risk2.png" alt="">
      </div>
      <div class="title">评分模型架构</div>
      <div>
        <img style="margin-bottom:60px;" src="../assets/product/risk3.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
    
    };
  },
  mounted() {
   
    
  },
  computed: {},
  methods: {
    
  },
};
</script>
<style scoped lang="scss">
.coat {
  width: 100%;
  
  .section{
    margin: 0 0 -5px;
    position: relative;
    color: #FFFFFF;
    img{
      width: 100%;
      height: auto;
    }
  }
  // 内容提示
  .tips{
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    div{
      margin-left: 12%;
      img{
      width: 12px;
      height: 12px;
      vertical-align: middle;

    }
    span{
      font-size: 10px;
      color: #808080;
      margin: 0 6px;
      display: inline-block;
      vertical-align: middle;
    }
    }
    
  }
  // 整体内容
  .main{
    width: 100%;
    background: #F5F5FA;
    text-align: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #405C80;
    padding: 60px 0;
    box-sizing: border-box;
    font-size: 28px;
    cursor: pointer;
    .title{
      margin: 60px auto;
    }
    p{
      color: #8D9BB9;
      font-size: 20px;
    }
    img{
      width: 55%;
      height: auto;
    }
  }
}
</style>
